var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHeartGray2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "4dami1hzda",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.674510 0 0 0 0 0.709804 0 0 0 0 0.741176 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#4dami1hzda)",
    transform: "translate(-72.000000, -514.000000) translate(16.000000, 514.000000) translate(56.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10 16.077l-.87-.796C6.04 12.46 4 10.6 4 8.32 4 6.46 5.452 5 7.3 5c1.044 0 2.046.49 2.7 1.262C10.654 5.489 11.656 5 12.7 5 14.548 5 16 6.46 16 8.32c0 2.282-2.04 4.142-5.13 6.967l-.87.79z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeartGray2);
export default __webpack_public_path__ + "static/media/ic_heart_gray2.c3b1957650486d94a682aa2317ad80fb.svg";
export { ForwardRef as ReactComponent };